import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { invalidateLists } from "store/api";

/**
 * Marks a cached RTK Query list (see LIST in store/api) as changed, so every
 * screen that shows it refetches. Call it after a create/update/delete.
 *
 *   const { refreshList, withListRefresh } = useListRefresh(LIST.tags);
 *   refreshList();                              // after a successful save
 *   deleteFn: withListRefresh(tagApi.deleteById) // refresh after the call
 */
const useListRefresh = (...types) => {
  const dispatch = useDispatch();
  const key = types.join(",");

  const refreshList = useCallback(
    () => dispatch(invalidateLists(...key.split(","))),
    [dispatch, key],
  );

  const withListRefresh = useCallback(
    (request) =>
      async (...args) => {
        const res = await request(...args);
        if (!res?.error) refreshList();
        return res;
      },
    [refreshList],
  );

  return useMemo(() => ({ refreshList, withListRefresh }), [refreshList, withListRefresh]);
};

export default useListRefresh;
